<template>
    <div>
        <b-card v-if="data" no-body
            :class="{ 'subscription-warning': data.numberOfDaysLeft <= 10 && !data.hasReservedSubscription, 'pulse-zoom': data.numberOfDaysLeft >= 0 && data.numberOfDaysLeft <= 10 && !data.hasReservedSubscription }">
            <b-card-header class="pb-0">
                <h4 class="mb-0 font-weight-bolder"
                    :class="{ 'text-danger': data.numberOfDaysLeft <= 10 && !data.hasReservedSubscription }">
                    اشتراک
                </h4>
            </b-card-header>

            <!-- apex chart -->
            <div v-if="data.numberOfDaysLeft >= 0">
                <vue-apex-charts type="radialBar" height="245" class="mb-1" :options="goalOverviewRadialBar"
                    :series="data.series" />
                <b-row class="text-center mx-0">
                    <b-col md="4" class="border-top border-right d-flex align-items-between flex-column py-1">
                        <b-card-text class="text-muted mb-50">
                            نام
                        </b-card-text>
                        <h4 class="mb-0 font-weight-bolder">
                            {{ data.subscriptionTitle }}
                        </h4>
                    </b-col>

                    <b-col md="4" class="border-top border-right d-flex align-items-between flex-column py-1">
                        <b-card-text class="text-muted mb-50">
                            باقی مانده
                        </b-card-text>
                        <h4 class="d-flex align-items-center justify-content-center mb-0">
                            <span class="font-weight-bolder"> {{ data.numberOfDaysLeft }} </span>
                            <span style="font-size: 16px;font-weight: 500;" class="text-muted ml-50">روز</span>
                        </h4>
                    </b-col>

                    <b-col md="4" class="border-top d-flex align-items-between flex-column py-1">
                        <b-card-text class="text-muted mb-50">
                            کل روز ها
                        </b-card-text>
                        <h4 class="d-flex align-items-center justify-content-center mb-0">
                            <span class="font-weight-bolder">{{ data.numberOfDays }}</span>
                            <span style="font-size: 16px;font-weight: 500;" class="text-muted ml-50">روز</span>
                        </h4>
                    </b-col>
                </b-row>
            </div>
            <div v-else style="height: 280px;" class="px-2">
                <div class="d-flex justify-content-center mb-1">
                    <feather-icon size="85" icon="AlertCircleIcon" color="#ff4158" />
                </div>
                <b-alert variant="primary" show>
                    <div class="alert-body text-center">
                        اشتراک شما به اتمام رسیده است. لطفا جهت تمدید اشتراک اقدام نمایید.
                    </div>
                </b-alert>
                <b-alert variant="danger" show>
                    <div class="alert-body text-center">
                        {{ `در صورتی که تا ${data.numberOfDaysLeft + 10} روز آینده حساب خود را شارژ نکنید، تمامی اطلاعات
                        شما
                        از سیستم منوتِک حذف خواهد
                        شد.` }}
                    </div>
                </b-alert>
            </div>
            <b-button @click="$router.push(`/subscription-management`)" class="mx-1 mb-1" variant="info">
                مدیریت اشتراک
            </b-button>
        </b-card>
    </div>
</template>

<script>
import { BCard, BCardHeader, BRow, BCol, BCardText, BButton, VBTooltip, BAlert } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'

const $strokeColor = '#ebe9f1'
const $textHeadingColor = '#5e5873'
const $goalStrokeColor2 = '#51e5a8'
export default {
    directives: {
        'b-tooltip': VBTooltip,
    },
    components: {
        VueApexCharts,
        BCard,
        BCardHeader,
        BRow,
        BCardText,
        BCol,
        BButton,
        BAlert
    },
    props: {
        data: {
            type: Object,
            default: () => { },
        },
    },
    data() {
        return {
            goalOverviewRadialBar: {
                chart: {
                    height: 245,
                    type: 'radialBar',
                    sparkline: {
                        enabled: true,
                    },
                    dropShadow: {
                        enabled: true,
                        blur: 3,
                        left: 1,
                        top: 1,
                        opacity: 0.1,
                    },
                },
                colors: [$goalStrokeColor2],
                plotOptions: {
                    radialBar: {
                        offsetY: -10,
                        startAngle: -150,
                        endAngle: 150,
                        hollow: {
                            size: '77%',
                        },
                        track: {
                            background: $strokeColor,
                            strokeWidth: '50%',
                        },
                        dataLabels: {
                            name: {
                                show: false,
                            },
                            value: {
                                color: $textHeadingColor,
                                fontSize: '2.86rem',
                                fontWeight: '600',
                            },
                        },
                    },
                },
                fill: {
                    type: 'gradient',
                    gradient: {
                        shade: 'dark',
                        type: 'horizontal',
                        shadeIntensity: 0.5,
                        gradientToColors: [$themeColors.primary],
                        inverseColors: true,
                        opacityFrom: 1,
                        opacityTo: 1,
                        stops: [0, 100],
                    },
                },
                stroke: {
                    lineCap: 'round',
                },
                grid: {
                    padding: {
                        bottom: 30,
                    },
                },
            },
        }
    },
}
</script>

<style lang="scss">
.subscription-warning {
    box-shadow: #ff4158 0px 0px 25px !important;
}

.pulse-zoom {
    animation: pulseZoom 1.5s ease-in-out infinite;
    transition: transform 0.3s ease-in-out;
}

.pulse-zoom:hover {
    animation: none;
    transform: scale(0.98);
}

@keyframes pulseZoom {
    0% {
        transform: scale(0.98);
    }

    50% {
        transform: scale(1.01);
    }

    100% {
        transform: scale(0.98);
    }
}
</style>